import { render, staticRenderFns } from "./BottomActions.vue?vue&type=template&id=fca46998&scoped=true&"
import script from "./BottomActions.vue?vue&type=script&lang=js&"
export * from "./BottomActions.vue?vue&type=script&lang=js&"
import style0 from "./BottomActions.vue?vue&type=style&index=0&id=fca46998&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca46998",
  null
  
)

export default component.exports